import React, { Component } from 'react';
import { styled } from '@material-ui/core/styles';
import { Box, TextField } from '@material-ui/core';
import Contacts from './Contacts';
import { ADD, EDIT, VIEW } from '../../../common/common';

const Root = styled(Box)({
    width: '100%',
    '& .pageTitle': {
        fontSize: '16px',
        fontWeight: 'bold',
        color: '#005E96',
    },
    '& .textWapper': {
        width: '100%',
        maxHeight: '717px',
        overflow: 'auto',
        '& .title': {
            fontSize: '18px',
            fontWeight: 'bold',
            color: '#212C31',
            marginTop: '18px',
        },
        '& .textField': {
            width: '45%',
            marginRight: '30px',
            backgroundColor: '#FFFFFF',
        },
        '& .state': {
            width: '26%',
            marginRight: '30px',
            backgroundColor: '#FFFFFF',
        },
        '& .country': {
            width: '35%',
            marginRight: '30px',
            backgroundColor: '#FFFFFF',
        },
        '& .zipCode': {
            width: '25%',
            marginRight: '30px',
            backgroundColor: '#FFFFFF',
        },
        '& .textGroup': {
            padding: '5px',
            marginBottom: '5px',
            backgroundColor: '#F2F0F3',
            '& .long': {
                width: '268px',
                margin: '5px',
                backgroundColor: '#fff',
            },
            '& .longer': {
                width: '466px',
                margin: '5px',
                backgroundColor: '#fff',
            },
            '& .short': {
                width: '188px',
                margin: '5px',
                backgroundColor: '#fff',
            },
        },
        '& .delWapper': {
            cursor: 'pointer',
            width: '87px',
            '& .del': {
                color: '#9B9B9B',
            },
        },
    },
    '& .notesText': {
        width: '100%',
        backgroundColor: '#FFFFFF',
    },
    '& .line': {
        width: '100%',
        height: '1px',
        backgroundColor: '#d8d8d8',
        margin: '20px 0',
    },
    '& .foot': {
        margin: '10px 0',
        '& .btn': {
            marginRight: '20px',
        },
    },
})

const POINTS = "points";
const RELATED = "related";
const MEMBERS = "members";
class ClientCorporation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: "",
            city: "",
            state: "",
            address: "",
            referral_source: "",
            points_of_contact: [{
                name: "",
                title: "",
                email: "",
                wechat: "",
                note: "",
                phone: ""
            }],
            related_parties: [{
                company_name: "",
                principal_name: "",
                principal_email: "",
                principal_phone: "",
                relationship: "",
                title: "",
            }],
            handler_id: "",
            note: "",
            members: [{
                name: "",
                type: "",
                title: "",
                email: "",
                wechat: "",
                note: "",
                phone: ""
            }],
            editable: true,
            contactsData: null,
            clientId: null
        }
        this.handleCancel = this.handleCancel.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleAddPoints = this.handleAddPoints.bind(this);
        this.handleAddRelated = this.handleAddRelated.bind(this);
        this.handleAddMembers = this.handleAddMembers.bind(this);
        this.handleDelet = this.handleDelet.bind(this);
    }
    render() {
        // const showDelBtn = (name, index) => {
        //     if (index === 0 || this.isDisabled()) {
        //         return <div className="delWapper">
        //         </div>
        //     } else {
        //         return <div className="delWapper c" onClick={e => this.handleDelet(e, name, index)}>
        //             <DeleteForeverIcon className="del d-e"></DeleteForeverIcon>
        //         </div>
        //     }
        // }
        const {
            name,
            city,
            state,
            address,
            // handler_id,
            note,
            contactsData,
            clientId
        } = this.state;
        return (
            <Root>
                <div className="textWapper">
                    <TextField
                        required
                        disabled={this.isDisabled()}
                        className="textField"
                        id="company"
                        label="Company Name"
                        value={name}
                        onChange={e => this.handleChange(e, 'name')}
                        margin="dense"
                        variant="outlined"
                        autoComplete="city"
                    />
                    <TextField
                        disabled={this.isDisabled()}
                        // select
                        className="textField"
                        id="state"
                        label="State"
                        value={state}
                        // onChange={e => this.handleSelect(e, "state")}
                        onChange={e => this.handleChange(e, "state")}
                        margin="dense"
                        variant="outlined"
                        autoComplete="city"
                    >
                        {/* {departmentsData.map(option => (
                                <MenuItem key={option.id} value={option.name}>
                                    {option.name}
                                </MenuItem>
                            ))} */}
                    </TextField>
                    <TextField
                        disabled={this.isDisabled()}
                        className="textField"
                        id="city"
                        label="City"
                        value={city}
                        onChange={e => this.handleChange(e, 'city')}
                        margin="dense"
                        variant="outlined"
                        autoComplete="city"
                    />
                    <TextField
                        disabled={this.isDisabled()}
                        className="textField"
                        id="address"
                        label="Address"
                        value={address}
                        onChange={e => this.handleChange(e, 'address')}
                        margin="dense"
                        variant="outlined"
                        autoComplete="city"
                    />

                    <div className="title">Points of Contact Info</div>
                    <Contacts
                        isAdd={this.props.state === ADD}
                        disabled={this.isDisabled()}
                        clientId={clientId}
                        data={contactsData}
                        ref={(child) => { this.contacts = child }}
                    ></Contacts>
                    <div className="title">Notes</div>
                    <TextField
                        disabled={this.isDisabled()}
                        id="notes"
                        className="notesText"
                        margin="dense"
                        variant="outlined"
                        multiline
                        rows="4"
                        inputProps={{ 'aria-label': 'bare' }}
                        value={note}
                        onChange={e => this.handleChange(e, 'note')}
                    />
                </div>
            </Root>
        )
    }
    componentDidMount() {
        this.initData();
    }
    getHandleData(name) {
        const { data } = this.props;
        if (!data) return null;
        const obj = this.extractAttorney();
        if (!obj) return "";
        const userObj = obj.user;
        const teamObj = obj.team;
        if (name === "office") {
            return teamObj ? teamObj.dept_info.office : "";
        } else if (name === "dept") {
            return teamObj ? teamObj.dept_info.id : "";
        } else if (name === "team") {
            return teamObj ? teamObj.id : "";
        } else if (name === "member") {
            return userObj ? userObj.id : "";
        } else if (name === "view") {
            return obj;
        }
    }
    extractAttorney() {
        const { data } = this.props;
        if (!data) return;
        let attorneyObj = {};
        const handlerArr = data.handler;
        if (!handlerArr) return null;
        for (const obj of handlerArr) {
            if (obj.is_origin_attorney) {
                attorneyObj = obj;
            }
        }
        return attorneyObj;
    }
    initData() {
        const { data, state } = this.props;
        console.log(data, state)
        if (state === VIEW || state === EDIT) {
            if (data) {
                const clientId = data.id;
                if (data.corporation) {
                    const name = data.corporation.name ? data.corporation.name : "";
                    const referral_source = data.corporation.referral_source ? data.corporation.referral_source : "";
                    const addressObj = data.corporation.address ? data.corporation.address : "";
                    const contactsData = data.contacts ? data.contacts : [];
                    const related_parties = data.related_parties ? data.related_parties : "";
                    const handler_id = data.handler ? data.handler.id : "";
                    const members = data.corporation.members ? data.corporation.members : "";
                    const note = data.note ? data.note : "";
                    const editable = data.editable ? data.editable : false;
                    let city = addressObj.city;
                    let state = addressObj.state;
                    let address = addressObj.address;
                    this.setState(() => ({
                        clientId,
                        name,
                        referral_source,
                        city,
                        state,
                        address,
                        contactsData,
                        related_parties,
                        handler_id,
                        members,
                        note,
                        editable,
                    }));
                }
            }
        }
    }
    isDisabled() {
        const { state } = this.props;
        if (state === ADD) {
            return false;
        } else if (state === VIEW) {
            return true;
        } else if (state === EDIT) {
            return false;
        }
    }
    handleChange(e, name) {
        const value = e.target.value;
        this.setState(() => ({
            [name]: value
        }))
    }
    handlePointsChange(e, index, name) {
        const value = e.target.value;
        const { points_of_contact } = this.state;
        let arr = points_of_contact;
        arr[index][name] = value;
        this.setState(() => ({
            points_of_contact: arr
        }))
    }
    handleOpposingChange(e, index, name) {
        const value = e.target.value;
        const { related_parties } = this.state;
        let arr = related_parties;
        arr[index][name] = value;
        this.setState(() => ({
            related_parties: arr
        }))
    }
    handleMembersChange(e, index, name) {
        const value = e.target.value;
        const { members } = this.state;
        let arr = members;
        arr[index][name] = value;
        this.setState(() => ({
            members: arr
        }))
    }
    handleAddPoints() {
        const { points_of_contact } = this.state;
        let obj = {
            name: "",
            title: "",
            email: "",
            wechat: "",
            note: "",
            phone: ""
        }
        let arr = points_of_contact;
        arr.push(obj)
        this.setState(() => ({
            points_of_contact: arr
        }))
    }
    handleAddMembers() {
        const { members } = this.state;
        let obj = {
            name: "",
            type: "",
            title: "",
            email: "",
            wechat: "",
            note: "",
            phone: ""
        }
        let arr = members;
        arr.push(obj)
        this.setState(() => ({
            members: arr
        }))
    }
    handleAddRelated() {
        const { related_parties } = this.state;
        let obj = {
            company_name: "",
            principal_name: "",
            principal_email: "",
            principal_phone: "",
            relationship: "",
            title: "",
        }
        let arr = related_parties;
        arr.push(obj)
        this.setState(() => ({
            related_parties: arr
        }))
    }
    handleDelet(e, name, index) {
        const { points_of_contact, related_parties, members } = this.state;
        if (name === POINTS) {
            let arr = points_of_contact;
            arr.splice(index, 1);
            this.setState(() => ({
                points_of_contact: arr
            }))
        } else if (name === RELATED) {
            let arr = related_parties;
            arr.splice(index, 1);
            this.setState(() => ({
                related_parties: arr
            }))
        } else if (name === MEMBERS) {
            let arr = members;
            arr.splice(index, 1);
            this.setState(() => ({
                members: arr
            }))
        }
    }
    handleSelect(e, name) {
        const value = e.target.value;
        this.setState(() => ({
            [name]: value
        }))
    }
    handleGetData() {
        const contacts = this.contacts.getData();
        // for (const obj of contacts) {
        //     for (const key in obj) {
        //         if (obj.hasOwnProperty(key)) {
        //             if (key === "client") {
        //                 delete obj[key];
        //             }
        //         }
        //     }
        // }
        const {
            name,
            city,
            state,
            address,
            note,
        } = this.state;
        const addressObj = {
            city,
            state,
            address
        };
        // let lObj = this.levelChoose.getData();
        // let userObj = {};
        // userObj.handler_id = lObj.handler_id;
        // userObj.handler_team_id = lObj.handler_team_id;
        // userObj.is_origin_attorney = true;
        // let handlers = [userObj];
        const obj = {
            // referral_source,
            // related_parties,
            name,
            address: addressObj,
            contacts,
            note,
            // members,
            // handlers,
        };
        return obj;
    }
    handleCancel() {
        this.props.handleCancel();
    }

    btnName(state) {
        if (state === ADD) {
            return "CREATE";
        } else if (state === EDIT) {
            return "SAVE";
        }
    }
}

export default ClientCorporation;